import type { Components, Theme } from '@mui/material'

type MuiPaperSettings = Components<Omit<Theme, 'components'>>['MuiPaper']

export const MuiPaper: MuiPaperSettings = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: 16,
      boxShadow: 'none',
      border: '1px solid',
      borderColor: theme.palette.grey[200],
    }),
  },
}
